import React from 'react';

const FormGroup = props => (
    <div className="form-group" style={props.style}>
        {props.children}
    </div>
);

export default FormGroup;